/**
 * ThemeToggle
 * -----------
 * Single button that cycles light -> dark -> system. The icon reflects
 * the CURRENT preference (sun / moon / monitor) so the user always
 * knows what state they're in -- crucial for the "system" mode since
 * the actual appearance depends on the OS.
 */
import { Monitor, Moon, Sun } from "lucide-react";
import { useTheme } from "@/theme/ThemeProvider";
import { cn } from "@/lib/utils";

interface Props {
  className?: string;
}

export default function ThemeToggle({ className }: Props) {
  const { theme, toggleTheme } = useTheme();
  const Icon = theme === "light" ? Sun : theme === "dark" ? Moon : Monitor;
  const label =
    theme === "light" ? "Light theme (click for dark)"
      : theme === "dark" ? "Dark theme (click for system)"
        : "System theme (click for light)";
  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={cn(
        "p-1.5 rounded-md hover:bg-muted transition-colors",
        "text-muted-foreground hover:text-foreground",
        className,
      )}
    >
      <Icon className="w-4 h-4" />
    </button>
  );
}
